// src/pages/SalesVoucher/components/CorporateVoucher.jsx
import React, { useEffect, useState } from "react";
import { Card, Typography } from "antd";
import { salesRecordWithDetailsApi } from "../../../apiservice/sales";

const { Title, Text } = Typography;

const CorporateVoucher = ({ sale_id, institution, authInfo, printMode = false }) => {
  const [data, setData] = useState(null);

  useEffect(() => {
    if (!sale_id) return;
    salesRecordWithDetailsApi({ sale_id, from: "voucher" })
      .then((res) => {
        if (res?.data?.length) {
          setData(res.data[0]);
        }
      })
      .catch((err) => console.error("Fetch corporate voucher failed", err));
  }, [sale_id]);

  if (!data) return null;

  return (
    <Card
      className="shadow-md rounded-xl mt-4 invoice-section"
      bordered={!printMode}      
      styles={{
      body: { padding: printMode ? "0" : "16px" },
    }}      
    >
      <Title level={5}>Corporate Sales Voucher</Title>
      <Text strong>Corporate Name: </Text> {data.corporate_name}
      <br />
      <Text strong>Voucher No: </Text> {data.voucher_no}
      <br />
      <Text strong>Grand Total: </Text> {data.grand_total}
    </Card>
  );
};

export default CorporateVoucher;
